import { render } from "./RefractoryConsumption.vue?vue&type=template&id=188b7663"
import script from "./RefractoryConsumption.vue?vue&type=script&lang=js"
export * from "./RefractoryConsumption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__